/**
 * This file was auto-generated by Fern from our API Definition.
 */
import * as core from "../../../../core";
import { GetRecordsResponseData } from "./GetRecordsResponseData";
export const GetRecordsResponse = core.serialization.object({
    data: GetRecordsResponseData,
});
